import { render, staticRenderFns } from "./HorseAge.vue?vue&type=template&id=05e4df79&"
import script from "./HorseAge.vue?vue&type=script&lang=js&"
export * from "./HorseAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports